/* ============================================================
   HARMONY — CERTIFICADO NFC (módulo 9)
   ============================================================
   Página aberta pelo link gravado no chip NFC de cada peça
   (/pages/certificado?n=037). Dono da peça vem do login real da conta
   Shopify (customer.id, Liquid) — nunca de um campo de texto/localStorage.
   Isso é diferente dos módulos 7 e 8 (certificados/rastreio), que ainda são
   100% front-end/demo: aqui a leitura já é dado real (metaobjeto
   "peca_numerada" da loja), só a ESCRITA (registrar/transferir) depende de
   um backend próprio (app + Cloudflare Worker) que valida a assinatura do
   Shopify App Proxy antes de gravar — token da Admin API nunca fica no
   navegador.

   O que este arquivo faz:
   - Lê "?n=" da URL (número da peça vinda do chip).
   - Cruza com dois blocos de dados que o Liquid já renderizou na página:
     1. #cl-public-data — { numero, produto, status } de TODAS as peças.
        Nunca inclui dono — é seguro mostrar pra quem não está logado.
     2. #cl-owned-data — peças que a CONTA LOGADA realmente possui. Isso já
        vem filtrado no servidor (Liquid comparando customer.id), então o
        JS não decide "de quem é a peça" — só decide o que mostrar.
   - Chama /apps/certificado/claim (Shopify App Proxy → Worker) quando a
     pessoa clica em "registrar/transferir". Enquanto esse app não estiver
     instalado e publicado, a chamada falha com 404 — tratado com uma
     mensagem clara, não com erro cru no console.
   ============================================================ */
(function () {
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function pad3(n) {
    return String(n).padStart(3, '0');
  }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function qrSvg(text) {
    try {
      if (typeof HarmonyQR === 'undefined') return '';
      var qr = HarmonyQR.encode(text);
      if (!qr) return '';
      var n = qr.size, q = 2, total = n + q * 2;
      return '<svg viewBox="0 0 ' + total + ' ' + total + '" role="img" aria-label="QR desta peça">'
        + '<rect width="' + total + '" height="' + total + '" fill="#f3f1eb"/>'
        + '<g transform="translate(' + q + ',' + q + ')" fill="#0a0a0a">'
        + '<path d="' + HarmonyQR.toPath(qr) + '"/></g></svg>';
    } catch (e) {
      return '';
    }
  }

  function init() {
    var root = document.querySelector('.hmy-certlookup-page');
    if (!root || root._hmyInit) return;
    root._hmyInit = true;

    var isLoggedIn = root.getAttribute('data-logged-in') === 'true';
    var loginUrl = root.getAttribute('data-login-url') || '/account/login';
    var claimEndpoint = root.getAttribute('data-claim-endpoint') || '/apps/certificado/claim';

    var publicData = readJSON('cl-public-data') || [];
    var ownedData = readJSON('cl-owned-data') || [];

    var params = new URLSearchParams(window.location.search);
    var requestedN = params.get('n');
    var requestedNum = requestedN ? parseInt(requestedN, 10) : null;

    var gateEl = document.getElementById('cl-gate');
    var teaserEl = document.getElementById('cl-teaser');
    var claimEl = document.getElementById('cl-claim');
    var mineEl = document.getElementById('cl-mine-doc');
    var gridEl = document.getElementById('cl-grid');
    var listHeadEl = document.getElementById('cl-list-head');
    var emptyEl = document.getElementById('cl-empty');

    function findPublic(num) {
      for (var i = 0; i < publicData.length; i++) {
        if (publicData[i].numero === num) return publicData[i];
      }
      return null;
    }
    function findOwned(num) {
      for (var i = 0; i < ownedData.length; i++) {
        if (ownedData[i].numero === num) return ownedData[i];
      }
      return null;
    }

    function loginLink() {
      var returnTo = window.location.pathname + window.location.search;
      var sep = loginUrl.indexOf('?') === -1 ? '?' : '&';
      return loginUrl + sep + 'return_url=' + encodeURIComponent(returnTo);
    }

    function renderGate(piece) {
      if (!gateEl) return;
      var pieceHint = piece ? ' Ela mostra a peça #' + pad3(piece.numero) + ' (' + esc(piece.produto_titulo) + ').' : '';
      gateEl.innerHTML = '<p>Essa página mostra o certificado da sua peça e deixa você transferir a titularidade quando repassar a camiseta.' + pieceHint + ' Faça login na sua conta Harmony pra continuar.</p>'
        + '<a class="cl-login-btn" href="' + loginLink() + '">FAZER LOGIN</a>';
      gateEl.hidden = false;
    }

    function renderTeaser(piece) {
      if (!teaserEl) return;
      if (!piece) {
        teaserEl.hidden = true;
        return;
      }
      var statusClass = piece.status === 'disponivel' ? 'available' : '';
      var statusLabel = piece.status === 'disponivel' ? 'AINDA NÃO REGISTRADA' : 'JÁ REGISTRADA POR ALGUÉM';
      teaserEl.innerHTML = ''
        + (piece.produto_imagem ? '<img src="' + esc(piece.produto_imagem) + '" alt="">' : '')
        + '<span>'
        + '<span class="cl-t-name">' + esc(piece.produto_titulo) + '</span>'
        + '<span class="cl-t-meta">PEÇA Nº ' + pad3(piece.numero) + ' / ' + piece.total + '</span>'
        + '<span class="cl-t-status ' + statusClass + '">' + statusLabel + '</span>'
        + '</span>';
      teaserEl.hidden = false;
    }

    function renderClaim(piece) {
      if (!claimEl) return;
      if (!isLoggedIn || !piece) {
        claimEl.hidden = true;
        return;
      }
      var label = piece.status === 'disponivel' ? 'REGISTRAR ESTA PEÇA COMO MINHA' : 'TRANSFERIR ESTA PEÇA PRA MIM';
      claimEl.innerHTML = '<button type="button" id="cl-claim-btn">' + label + '</button>'
        + '<p class="cl-claim-msg" id="cl-claim-msg" hidden></p>';
      claimEl.hidden = false;

      var btn = document.getElementById('cl-claim-btn');
      var msgEl = document.getElementById('cl-claim-msg');
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = 'REGISTRANDO...';
        msgEl.hidden = true;

        fetch(claimEndpoint + '?handle=' + pad3(piece.numero), { method: 'POST' })
          .then(function (r) {
            if (!r.ok) throw { status: r.status };
            return r.json();
          })
          .then(function () {
            msgEl.className = 'cl-claim-msg ok';
            msgEl.textContent = 'Peça registrada na sua conta. Atualizando...';
            msgEl.hidden = false;
            setTimeout(function () { window.location.reload(); }, 900);
          })
          .catch(function (err) {
            btn.disabled = false;
            btn.textContent = original;
            msgEl.className = 'cl-claim-msg error';
            if (err && err.status === 404) {
              msgEl.textContent = 'O registro por NFC ainda não está disponível nesta loja (backend do módulo 9 ainda não publicado).';
            } else {
              msgEl.textContent = 'Não deu pra registrar agora. Tente de novo em instantes.';
            }
            msgEl.hidden = false;
          });
      });
    }

    function renderMineDoc(piece) {
      if (!mineEl) return;
      if (!piece) {
        mineEl.hidden = true;
        return;
      }
      var shareUrl = window.location.origin + '/pages/certificado?n=' + pad3(piece.numero);
      mineEl.innerHTML = ''
        + '<div class="cert-doc">'
        + '<div class="brackets">'
        + '<span class="corner c-tl"><svg viewBox="0 0 16 16"><path d="M0 0H16V2H2V16H0V0Z" fill="currentColor"/></svg></span>'
        + '<span class="corner c-tr"><svg viewBox="0 0 16 16"><path d="M0 0H16V2H2V16H0V0Z" fill="currentColor"/></svg></span>'
        + '<span class="corner c-bl"><svg viewBox="0 0 16 16"><path d="M0 0H16V2H2V16H0V0Z" fill="currentColor"/></svg></span>'
        + '<span class="corner c-br"><svg viewBox="0 0 16 16"><path d="M0 0H16V2H2V16H0V0Z" fill="currentColor"/></svg></span>'
        + '</div>'
        + '<div class="cd-rule"></div>'
        + '<div class="cd-inner">'
        + '<div class="cd-head">'
        + '<span class="cd-label">CERTIFICADO DE AUTENTICIDADE</span>'
        + '<span class="cd-ref">HMY / NFC / PEÇA #' + pad3(piece.numero) + '</span>'
        + '</div>'
        + '<div class="cd-body">'
        + '<div class="cd-stage"><div class="cd-plate">'
        + (piece.produto_imagem ? '<img src="' + esc(piece.produto_imagem) + '" alt="' + esc(piece.produto_titulo) + '">' : '')
        + '</div></div>'
        + '<div class="cd-side">'
        + '<h4 class="cd-name">' + esc(piece.produto_titulo) + '</h4>'
        + '<span class="cd-sub">PEÇA Nº ' + pad3(piece.numero) + ' / ' + piece.total + '</span>'
        + '<div class="cd-rows">'
        + '<div class="cd-row"><span class="cd-k">STATUS</span><span class="cd-v sig">REGISTRADA NA SUA CONTA</span></div>'
        + (piece.data_venda ? '<div class="cd-row"><span class="cd-k">DATA DE REGISTRO</span><span class="cd-v">' + esc(piece.data_venda) + '</span></div>' : '')
        + '</div>'
        + '</div>'
        + '</div>'
        + '<div class="cd-foot">'
        + '<div class="cd-qr">' + qrSvg(shareUrl) + '</div>'
        + '<div class="cd-state"><span class="st-l on">SUA PEÇA</span>'
        + '<span class="st-d">Repassou a camiseta? Quem ficar com ela loga aqui e transfere pra própria conta.</span></div>'
        + '</div>'
        + '</div>'
        + '</div>';
      mineEl.hidden = false;
    }

    function renderGrid(featuredNum) {
      if (!gridEl) return;
      var others = ownedData.filter(function (p) { return p.numero !== featuredNum; });
      var toList = featuredNum ? others : ownedData;

      if (isLoggedIn && ownedData.length === 0) {
        if (emptyEl) emptyEl.hidden = false;
        if (listHeadEl) listHeadEl.hidden = true;
        gridEl.hidden = true;
        return;
      }
      if (!isLoggedIn || toList.length === 0) {
        gridEl.hidden = true;
        if (listHeadEl) listHeadEl.hidden = true;
        return;
      }

      if (listHeadEl) listHeadEl.hidden = false;
      gridEl.innerHTML = '';
      toList.forEach(function (p) {
        var card = document.createElement('a');
        card.className = 'cl-card';
        card.href = '?n=' + pad3(p.numero);
        card.innerHTML = (p.produto_imagem ? '<img src="' + esc(p.produto_imagem) + '" alt="">' : '')
          + '<span><span class="cl-c-name">' + esc(p.produto_titulo) + '</span>'
          + '<span class="cl-c-meta">Nº ' + pad3(p.numero) + '</span></span>';
        gridEl.appendChild(card);
      });
      gridEl.hidden = false;
    }

    // ---------- decide o que mostrar ----------
    if (!isLoggedIn) {
      var publicPiece = requestedNum ? findPublic(requestedNum) : null;
      renderGate(publicPiece);
      renderTeaser(publicPiece);
      renderClaim(null);
      renderMineDoc(null);
      renderGrid(null);
      return;
    }

    if (gateEl) gateEl.hidden = true;

    if (requestedNum) {
      var mine = findOwned(requestedNum);
      if (mine) {
        renderTeaser(null);
        renderClaim(null);
        renderMineDoc(mine);
        renderGrid(requestedNum);
      } else {
        var pub = findPublic(requestedNum);
        renderTeaser(pub);
        renderClaim(pub);
        renderMineDoc(null);
        renderGrid(null);
      }
    } else {
      renderTeaser(null);
      renderClaim(null);
      renderMineDoc(null);
      renderGrid(null);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
